import { useState } from 'react';
import LogoMark from '../components/LogoMark';
import { apiFetch } from '../config/api';
import styles from './Login.module.css';

export default function Login({ onLogin, onRegister, onReset }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await apiFetch('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim(), password }),
      });
      onLogin({ ...data.user, token: data.token });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={`glass-card ${styles.card}`}>

        {/* Logo */}
        <div className={styles.logoRow}>
          <LogoMark size={28} />
          <span className={styles.logoText}>car-pool</span>
        </div>

        <h1 className={styles.heading}>Welcome back</h1>
        <p className={styles.sub}>Sign in to your account</p>

        {error && <div className={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label}>Email</label>
            <input
              type="email"
              className={`glass-input ${styles.input}`}
              placeholder="you@school.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Password</label>
            <input
              type="password"
              className={`glass-input ${styles.input}`}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p className={styles.forgot}>
          Forgot your password?{' '}
          <button type="button" onClick={onReset} className={styles.forgotLink} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 'inherit', padding: 0 }}>Click here to reset it</button>
        </p>

        <p className={styles.note}>
          Need a staff account?{' '}
          {onRegister
            ? <button type="button" onClick={onRegister} style={{ background:'none', border:'none', cursor:'pointer', color:'#fff', fontWeight:700, textDecoration:'underline', fontSize:'inherit', padding:0 }}>Request access</button>
            : 'Contact your school administrator.'
          }
        </p>
      </div>
    </div>
  );
}
